var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("SoliForm", {
        ref: "form",
        attrs: {
          title: _vm.getFormTitle,
          text: "Save",
          icon: "save",
          error: _vm.errors,
          limitScroll: "",
          persistent: _vm.step >= 2,
          saveChanges:
            (_vm.saveChanges || _vm.cancelAvail) && !_vm.futureConflict,
          selection: _vm.getSelection,
          hideBtn: _vm.hideSaveBtn,
          extraBtn: _vm.hideSaveBtn,
        },
        on: {
          submit: function ($event) {
            _vm.editing ? _vm.editEvent() : _vm.addEvent()
          },
          reset: _vm.reset,
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _vm.futureConflict
                  ? _c("SoliChoice", {
                      attrs: {
                        title: "Hey!",
                        subtitle: `${
                          _vm.$page.props.auth.user.id == _vm.teacher.id
                            ? "You are "
                            : `${_vm.teacher.first_name} is `
                        } ${
                          _vm.futureConflict.recurrence_id
                            ? `already scheduled during this time, starting ${_vm.globalMomentDate(
                                new Date(_vm.futureConflict.date)
                              )}. Would you like to schedule until then?`
                            : `unavailable at this time.`
                        }`,
                        button1: _vm.futureConflict.recurrence_id ? "Ok" : null,
                        button2: !_vm.futureConflict.recurrence_id
                          ? "Ok"
                          : "Go Back",
                      },
                      on: {
                        option1: function ($event) {
                          ;[
                            (_vm.form.recurrence_end = _vm.futureConflict.date),
                            (_vm.futureConflict = null),
                            (_vm.form.noConflict = true),
                            (_vm.$refs.form.loading = true),
                            _vm.editing ? _vm.editEvent() : _vm.addEvent(),
                          ]
                        },
                        option2: function ($event) {
                          ;[
                            (_vm.futureConflict = null),
                            (_vm.form.noConflict = false),
                            (_vm.step = 1),
                            (_vm.$refs.form.loading = false),
                          ]
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.formError
                  ? _c("SoliChoice", {
                      attrs: {
                        title: "Uh oh",
                        subtitle: _vm.formError,
                        button1: "Okay",
                      },
                      on: {
                        option1: function ($event) {
                          _vm.closeModal(() => {
                            _vm.formError = null
                            _vm.futureConflict = null
                            _vm.form.noConflict = false
                            _vm.step = 1
                            _vm.$refs.form.loading = false
                          })
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.step >= 2 && _vm.step !== _vm.finalStep
                  ? _c("v-row", { staticClass: "pa-4" }, [
                      _c(
                        "div",
                        { staticClass: "my-4 ml-3 soli-grey" },
                        [
                          _c(
                            "v-progress-circular",
                            {
                              staticClass: "mr-5",
                              attrs: {
                                value: _vm.progressVal,
                                rotate: 180,
                                size: 55,
                                color: "#228cbd",
                              },
                            },
                            [
                              _c("div", { staticClass: "progress-text" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.step) +
                                    " of " +
                                    _vm._s(_vm.finalStep) +
                                    "\n                        "
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(
                            _vm._s(_vm.getStepperTitle) + "\n                "
                          ),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "v-stepper",
                  {
                    key: _vm.whichSteps[0].steps,
                    staticClass: "elevation-0",
                    staticStyle: { "margin-top": "-12px" },
                    model: {
                      value: _vm.step,
                      callback: function ($$v) {
                        _vm.step = $$v
                      },
                      expression: "step",
                    },
                  },
                  [
                    _vm.findStep("edit")
                      ? _c(
                          "v-stepper-content",
                          {
                            staticClass: "pa-0",
                            attrs: { step: _vm.findStep("edit") },
                          },
                          [
                            !_vm.editing
                              ? _c("v-switch", {
                                  staticClass: "px-2",
                                  attrs: { label: "Repeats Weekly", dense: "" },
                                  on: { change: _vm.updateRepeating },
                                  model: {
                                    value: _vm.form.repeating,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "repeating", $$v)
                                    },
                                    expression: "form.repeating",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("v-switch", {
                              class: [!_vm.editing ? "mt-0" : "my-3", "px-2"],
                              attrs: {
                                disabled:
                                  (_vm.editing &&
                                    _vm.hasLessons &&
                                    _vm.saveChanges) ||
                                  (_vm.editing &&
                                    _vm.hasLessons &&
                                    _vm.form.online_only),
                                label: "Online Only",
                                dense: "",
                              },
                              on: {
                                change: function ($event) {
                                  _vm.hasLessons
                                    ? ((_vm.moveOnline = true),
                                      _vm.step++,
                                      _vm.getAffectedLessons())
                                    : null
                                },
                              },
                              model: {
                                value: _vm.form.online_only,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "online_only", $$v)
                                },
                                expression: "form.online_only",
                              },
                            }),
                            _vm._v(" "),
                            _c("div", {
                              class: [!_vm.editing ? "mt-0" : "my-3", "px-2"],
                            }),
                            _vm._v(" "),
                            _vm.teacher.locations.length > 1
                              ? _c("SoliUserLocation", {
                                  key: _vm.form.online_only,
                                  attrs: {
                                    locations: _vm.teacher.locations,
                                    disabled: _vm.avail.event
                                      ? !!_vm.avail.event.extendedProps
                                          .assignments.length
                                      : false,
                                    rules: _vm.rules.select,
                                  },
                                  model: {
                                    value: _vm.form.locations,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "locations", $$v)
                                    },
                                    expression: "form.locations",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.editing
                              ? _c("SoliDate", {
                                  attrs: {
                                    label: "Start Date",
                                    error: _vm.errors.starts_at,
                                    rules: _vm.rules.input,
                                    noLimit: "",
                                  },
                                  model: {
                                    value: _vm.form.startDate,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "startDate", $$v)
                                    },
                                    expression: "form.startDate",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("SoliTime", {
                              attrs: {
                                "error-messages": _vm.errors.starts_at,
                                rules: _vm.rules.input,
                              },
                              model: {
                                value: _vm.form.startTime,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "startTime", $$v)
                                },
                                expression: "form.startTime",
                              },
                            }),
                            _vm._v(" "),
                            _c("SoliTime", {
                              attrs: {
                                label: "End Time",
                                icon: "timer_off",
                                "error-messages": _vm.errors.ends_at,
                                rules: _vm.rules.input,
                              },
                              model: {
                                value: _vm.form.endTime,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "endTime", $$v)
                                },
                                expression: "form.endTime",
                              },
                            }),
                            _vm._v(" "),
                            _c("v-select", {
                              attrs: {
                                multiple: "",
                                items: _vm.lessonTypes,
                                "item-text": "name",
                                "item-value": "name",
                                label: "Services",
                                "prepend-inner-icon": "event_available",
                                outlined: "",
                                dense: "",
                              },
                              model: {
                                value: _vm.form.selectedTypes,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "selectedTypes", $$v)
                                },
                                expression: "form.selectedTypes",
                              },
                            }),
                            _vm._v(" "),
                            _c("SoliUserInstruments", {
                              attrs: {
                                instruments: _vm.teacher.instruments,
                                multiple: "",
                              },
                              model: {
                                value: _vm.form.instruments,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "instruments", $$v)
                                },
                                expression: "form.instruments",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.findStep("selectRecurring")
                      ? _c(
                          "v-stepper-content",
                          {
                            staticClass: "pa-0",
                            attrs: { step: _vm.findStep("selectRecurring") },
                          },
                          [
                            _c(
                              "v-list-item",
                              [
                                _c("SoliBtn", {
                                  staticClass: "mb-3",
                                  attrs: {
                                    disabled:
                                      (_vm.hasLessons && _vm.cancelAvail) ||
                                      _vm.affectedLessonsLength > 0 ||
                                      _vm.futureLessons ||
                                      _vm.removedFromSeries,
                                    text: "This and Future Events",
                                    block: "",
                                    color: "soli-grey",
                                    outlined: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.handleSelectFuture(), _vm.step++
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-list-item",
                              [
                                _c("SoliBtn", {
                                  staticClass: "mb-3",
                                  attrs: {
                                    text: "This Event",
                                    block: "",
                                    color: "soli-grey",
                                    outlined: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.handleSelectSingle(), _vm.step++
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.findStep("affected")
                      ? _c(
                          "v-stepper-content",
                          {
                            staticClass: "pa-0",
                            attrs: { step: _vm.findStep("affected") },
                          },
                          [
                            _c(
                              "v-list",
                              { staticClass: "pt-0" },
                              [
                                _vm._l(
                                  _vm.affectedLessons.filter(
                                    (e) => e.students.length && !e.cancelled
                                  ),
                                  function (lesson) {
                                    return _c(
                                      "div",
                                      { key: lesson.id },
                                      _vm._l(
                                        lesson.students,
                                        function (student) {
                                          return _c(
                                            "v-list-item",
                                            { key: student.id },
                                            [
                                              _c(
                                                "v-list-item-content",
                                                { staticClass: "soli-grey" },
                                                [
                                                  _c(
                                                    "v-row",
                                                    {
                                                      staticClass:
                                                        "whitespace-nowrap flex-nowrap",
                                                      attrs: {
                                                        "no-gutters": "",
                                                        justify:
                                                          "space-between",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "shrink flex-1 justify-start",
                                                        },
                                                        [
                                                          _c("small", [
                                                            _vm._v(
                                                              "\n                                                " +
                                                                _vm._s(
                                                                  student.email
                                                                ) +
                                                                "\n                                            "
                                                            ),
                                                          ]),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-list-item-title",
                                                            [
                                                              _vm._v(
                                                                "\n                                                " +
                                                                  _vm._s(
                                                                    student.name
                                                                  ) +
                                                                  "\n                                            "
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("small", [
                                                            _vm._v(
                                                              _vm._s(
                                                                `${
                                                                  lesson.group_event
                                                                    ? lesson
                                                                        .group_event
                                                                        .title
                                                                    : lesson
                                                                        .instrument
                                                                        .name
                                                                } · ${_vm.globalMomentTime(
                                                                  lesson.starts_at
                                                                )}`
                                                              )
                                                            ),
                                                          ]),
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "flex grow gap-2 justify-end absolute right-0 white",
                                                        },
                                                        [
                                                          _c(
                                                            "v-btn",
                                                            {
                                                              staticClass:
                                                                "soli-blue-text",
                                                              attrs: {
                                                                icon: "",
                                                                large: "",
                                                                href: `tel:${student.phone}`,
                                                              },
                                                            },
                                                            [
                                                              _c("v-icon", [
                                                                _vm._v("phone"),
                                                              ]),
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-btn",
                                                            {
                                                              staticClass:
                                                                "soli-blue-text",
                                                              attrs: {
                                                                icon: "",
                                                                large: "",
                                                                href: `sms:${student.phone}`,
                                                              },
                                                            },
                                                            [
                                                              _c("v-icon", [
                                                                _vm._v("sms"),
                                                              ]),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      1
                                    )
                                  }
                                ),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.affectedLessons.filter(
                                    (e) => !e.students.length
                                  ),
                                  function (lesson) {
                                    return _c(
                                      "v-list-item",
                                      { key: lesson.id },
                                      [
                                        _c(
                                          "v-list-item-content",
                                          { staticClass: "soli-grey" },
                                          [
                                            _c(
                                              "v-row",
                                              [
                                                _c("v-col", [
                                                  _c("small", [
                                                    _vm._v(
                                                      _vm._s(
                                                        `${
                                                          lesson.group_event_id
                                                            ? lesson.group_event
                                                                .title
                                                            : lesson.instrument
                                                            ? lesson.instrument
                                                                .name
                                                            : "Hold"
                                                        } · ${_vm.globalMomentTime(
                                                          lesson.starts_at
                                                        )}`
                                                      )
                                                    ),
                                                  ]),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  }
                                ),
                              ],
                              2
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.findStep("email")
                      ? _c(
                          "v-stepper-content",
                          {
                            staticClass: "pa-0",
                            attrs: { step: _vm.findStep("email") },
                          },
                          [
                            _c(
                              "v-list",
                              [
                                _c(
                                  "v-list-item",
                                  { staticClass: "px-3" },
                                  [
                                    _c(
                                      "v-textarea",
                                      {
                                        ref: "email",
                                        attrs: {
                                          outlined: "",
                                          dense: "",
                                          label: "Your message",
                                          disabled: _vm.form.skipEmail,
                                          rules:
                                            _vm.getStepperTitle == "Send Email?"
                                              ? _vm.emailBodyRule
                                              : [],
                                        },
                                        model: {
                                          value: _vm.emailBody,
                                          callback: function ($$v) {
                                            _vm.emailBody = $$v
                                          },
                                          expression: "emailBody",
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.emailBody))]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-list-item",
                                  {
                                    staticClass: "pb-0 pt-8",
                                    staticStyle: { "min-height": "3px" },
                                  },
                                  [_c("v-divider", { attrs: { inset: "" } })],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-list-item",
                                  { staticClass: "float-right" },
                                  [
                                    _c("v-switch", {
                                      attrs: {
                                        color: "red",
                                        label: "No thanks",
                                      },
                                      model: {
                                        value: _vm.form.skipEmail,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "skipEmail", $$v)
                                        },
                                        expression: "form.skipEmail",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.findStep("confirm")
                      ? _c(
                          "v-stepper-content",
                          {
                            staticClass: "pa-0",
                            attrs: { step: _vm.findStep("confirm") },
                          },
                          [
                            _c(
                              "v-list",
                              { staticClass: "px-1 soli-grey" },
                              [
                                !_vm.cancelAvail
                                  ? _c(
                                      "div",
                                      [
                                        _c("div", { staticClass: "mb-5" }, [
                                          _c(
                                            "div",
                                            { staticClass: "caption" },
                                            [_vm._v("Original")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              class: ["flex align-center mt-1"],
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "mr-1",
                                                  attrs: {
                                                    "x-small": "",
                                                    color: "#4b6876",
                                                  },
                                                },
                                                [_vm._v("today")]
                                              ),
                                              _vm._v(" "),
                                              _c("small", [
                                                _vm._v(
                                                  _vm._s(
                                                    `${
                                                      _vm.formCopy
                                                        .originalStartDate
                                                    }${
                                                      _vm.getRecurrenceEnd
                                                        ? ` until ${_vm.getRecurrenceEnd}`
                                                        : ""
                                                    }`
                                                  )
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              class: ["flex align-center mt-1"],
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "mr-1",
                                                  attrs: {
                                                    "x-small": "",
                                                    color: "#4b6876",
                                                  },
                                                },
                                                [_vm._v("repeat")]
                                              ),
                                              _vm._v(" "),
                                              _c("small", [
                                                _vm._v(
                                                  _vm._s(`
                                        Weekly on ${_vm.globalMomentWeekDay(
                                          new Date(
                                            _vm.formCopy.originalStartDate
                                          )
                                        )}s`)
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              class: ["flex align-center mt-1"],
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "mr-1",
                                                  attrs: {
                                                    "x-small": "",
                                                    color: "#4b6876",
                                                  },
                                                },
                                                [_vm._v("schedule")]
                                              ),
                                              _vm._v(" "),
                                              _c("small", [
                                                _vm._v(
                                                  _vm._s(
                                                    `${_vm.formCopy.originalStartTime} to ${_vm.formCopy.originalEndTime} `
                                                  )
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm.showInstruments
                                            ? _c(
                                                "div",
                                                {
                                                  class: [
                                                    "flex align-center mt-1",
                                                  ],
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "mr-1",
                                                      attrs: {
                                                        "x-small": "",
                                                        color: "#4b6876",
                                                      },
                                                    },
                                                    [_vm._v("music_note")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("small", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formCopy.originalInstruments
                                                          .map((e) => e.name)
                                                          .toString() + " "
                                                      )
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.showSelectedTypes
                                            ? _c(
                                                "div",
                                                {
                                                  class: [
                                                    "flex align-center mt-1",
                                                  ],
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "mr-1",
                                                      attrs: {
                                                        "x-small": "",
                                                        color: "#4b6876",
                                                      },
                                                    },
                                                    [_vm._v("filter_list")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("small", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formCopy.originalSelectedTypes
                                                          .map((e) => e.name)
                                                          .toString()
                                                      )
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.showOnline
                                            ? _c(
                                                "div",
                                                {
                                                  class: [
                                                    "flex align-center mt-1",
                                                  ],
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "mr-1",
                                                      attrs: {
                                                        "x-small": "",
                                                        color: "#4b6876",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.formCopy
                                                            .originalOnlineOnly
                                                            ? "videocam"
                                                            : "meeting_room"
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("small", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formCopy
                                                          .originalOnlineOnly
                                                          ? "Online"
                                                          : "In-studio"
                                                      )
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ]),
                                        _vm._v(" "),
                                        _c("v-divider"),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "my-5" }, [
                                          _c(
                                            "div",
                                            { staticClass: "caption" },
                                            [_vm._v("Update")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              class: ["flex align-center mt-1"],
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "mr-1",
                                                  attrs: {
                                                    "x-small": "",
                                                    color: "#4b6876",
                                                  },
                                                },
                                                [_vm._v("today")]
                                              ),
                                              _vm._v(" "),
                                              _vm.form.futureEvents
                                                ? _c("small", [
                                                    _vm._v(
                                                      _vm._s(
                                                        `${_vm.form.startDate}${
                                                          _vm.getRecurrenceEnd
                                                            ? ` until ${_vm.getRecurrenceEnd}`
                                                            : " and future events"
                                                        }`
                                                      )
                                                    ),
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.form.futureEvents
                                                ? _c("small", [
                                                    _vm._v(
                                                      _vm._s(
                                                        `Editing only ${_vm.form.startDate}`
                                                      )
                                                    ),
                                                  ])
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              class: ["flex align-center mt-1"],
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "mr-1",
                                                  attrs: {
                                                    "x-small": "",
                                                    color: "#4b6876",
                                                  },
                                                },
                                                [_vm._v("repeat")]
                                              ),
                                              _vm._v(" "),
                                              _c("small", [
                                                _vm._v(
                                                  _vm._s(`
                                        Weekly on ${_vm.globalMomentWeekDay(
                                          new Date(
                                            _vm.formCopy.originalStartDate
                                          )
                                        )}s`)
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              class: ["flex align-center mt-1"],
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "mr-1",
                                                  attrs: {
                                                    "x-small": "",
                                                    color: "#4b6876",
                                                  },
                                                },
                                                [_vm._v("schedule")]
                                              ),
                                              _vm._v(" "),
                                              _c("small", [
                                                _vm._v(
                                                  _vm._s(
                                                    `${_vm.form.startTime} to ${_vm.form.endTime}`
                                                  )
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm.showInstruments
                                            ? _c(
                                                "div",
                                                {
                                                  class: [
                                                    "flex align-center mt-1",
                                                  ],
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "mr-1",
                                                      attrs: {
                                                        "x-small": "",
                                                        color: "#4b6876",
                                                      },
                                                    },
                                                    [_vm._v("music_note")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("small", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.form.instruments
                                                          .map((e) => e.name)
                                                          .toString()
                                                      )
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.showSelectedTypes
                                            ? _c(
                                                "div",
                                                {
                                                  class: [
                                                    "flex align-center mt-1",
                                                  ],
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "mr-1",
                                                      attrs: {
                                                        "x-small": "",
                                                        color: "#4b6876",
                                                      },
                                                    },
                                                    [_vm._v("filter_list")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("small", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.form.selectedTypes
                                                          .map((e) => e.name)
                                                          .toString()
                                                      )
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.showOnline
                                            ? _c(
                                                "div",
                                                {
                                                  class: [
                                                    "flex align-center mt-1",
                                                  ],
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "mr-1",
                                                      attrs: {
                                                        "x-small": "",
                                                        color: "#4b6876",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.form.online_only
                                                            ? "videocam"
                                                            : "meeting_room"
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("small", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.form.online_only
                                                          ? "Online"
                                                          : "In-studio"
                                                      )
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ]),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.cancelAvail ? _c("v-divider") : _vm._e(),
                                _vm._v(" "),
                                _vm.cancelAvail
                                  ? _c("div", [
                                      _c("div", { staticClass: "mb-5" }, [
                                        _c("div", { staticClass: "caption" }, [
                                          _vm._v(
                                            "\n                                    Cancel Availability\n                                "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("div", [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                `${_vm.form.startDate} ${
                                                  _vm.form.futureEvents
                                                    ? `and all future events`
                                                    : ""
                                                }`
                                              ) +
                                              "\n                                "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("small", [
                                          _vm._v(
                                            _vm._s(
                                              `${_vm.form.startTime} to ${_vm.form.endTime}`
                                            )
                                          ),
                                        ]),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "mt-5" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "caption",
                                      staticStyle: {
                                        "line-height": "unset !important",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                Affected Lessons\n                            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          `${
                                            _vm.affectedLessonsLength
                                          } lesson(s) will be ${
                                            _vm.moveOnline
                                              ? "moved online"
                                              : "cancelled"
                                          }`
                                        ) +
                                        "\n                            "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("small", [
                                    _vm._v(
                                      _vm._s(
                                        `Clients ${
                                          _vm.form.skipEmail ||
                                          _vm.affectedLessonsLength == 0
                                            ? "will NOT be"
                                            : "will be"
                                        } emailed`
                                      )
                                    ),
                                  ]),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "cancelBtn",
            fn: function (attrs) {
              return [
                _vm.editing &&
                _vm.step !== _vm.finalStep &&
                _vm.step !== _vm.findStep("selectRecurring")
                  ? _c(
                      "SoliBtn",
                      _vm._b(
                        {
                          staticClass: "mt-3",
                          attrs: {
                            disabled:
                              (!_vm.saveChanges && _vm.step == 1) ||
                              !!_vm.futureConflict,
                            text: "Next Step",
                            icon: "chevron_right",
                            color: "soli-blue",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.nextStep()
                            },
                          },
                        },
                        "SoliBtn",
                        attrs,
                        false
                      )
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.hideSaveBtn && _vm.step == 1 && !_vm.saveChanges
                  ? _c(
                      "SoliBtn",
                      _vm._b(
                        {
                          staticClass: "mt-3",
                          attrs: {
                            text: _vm.hasLessons ? "Time-off" : "Delete",
                            icon: _vm.hasLessons ? "event_busy" : "delete",
                            color: "soli-status-red",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.handleDeleteBtn()
                            },
                          },
                        },
                        "SoliBtn",
                        attrs,
                        false
                      )
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.step >= 2
                  ? _c(
                      "SoliBtn",
                      _vm._b(
                        {
                          staticClass: "mt-3",
                          attrs: {
                            text: "Back a step",
                            icon: "chevron_left",
                            left: "",
                            color: "grey",
                          },
                          on: {
                            click: function ($event) {
                              _vm.step--
                            },
                          },
                        },
                        "SoliBtn",
                        attrs,
                        false
                      )
                    )
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _vm.editAvailWarning
        ? _c("SoliChoice", {
            ref: "editAvailWarning",
            attrs: {
              title: "Heads up!",
              subtitle: `${
                _vm.editFutureAvailWarning
                  ? "Future availabilities in this series contain "
                  : "This availability contains "
              } lessons now or in the future. Making changes will only edit the selected date and not future events. If you'd like to edit all future availability in this series, please cancel these lessons first.`,
              button1: "Okay",
            },
            on: {
              option1: function ($event) {
                return _vm.resetEditAvailWarning()
              },
              reset: function ($event) {
                return _vm.resetEditAvailWarning()
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.groupEventWarning
        ? _c("SoliChoice", {
            ref: "groupEventWarning",
            attrs: {
              title: "Heads up!",
              subtitle: `
            This availability contains group event(s) and cannot be edited at this time. Please cancel the group event before proceeding.`,
              button1: "Okay",
            },
            on: {
              option1: function ($event) {
                return _vm.resetGroupEventWarning()
              },
              reset: function ($event) {
                return _vm.resetGroupEventWarning()
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }